<template>

  <nuxt-link class="vz-link" v-if="internal" :to="to"><slot></slot></nuxt-link>
  <a class="vz-link" v-else :href="to"><slot></slot></a>

</template>

<script>
import VzBase from '../vz-base.vue';

export default {

  name: 'VzLink',
  extends: VzBase,

  props: {
    to: {
      type: String,
      default: '/'
    }
  },

  computed: {

    internal: function () {
      return this.to.substr(0, 1) === '/';
    }

  }

}
</script>

<style>

</style>